<template>
  <b-row class="justify-content-md-center m-0">
    <b-col lg="8">
      <base-bread-crumb :items="breadcrumbs" />

      <b-button variant="outline-primary" class="mb-4 btn__previous-page" @click="gotoPreviousPage">
        Back to previous page
      </b-button>

      <learning-unit-header
        v-if="$_feedMixin_learningUnit"
        :learning-unit="$_feedMixin_learningUnit"
        :show-alert-review="mode === 'instructor'"
      ></learning-unit-header>

      <!-- <div
        v-if="$_feedMixin_learningUnit"
        class="
          h5
          display-4
          font-weight-bold
          mb-3
          header__lu-title
          text__lu-title
        "
      >
        {{ $_feedMixin_learningUnit.name }}
      </div> -->

      <b-row>
        <b-col sm="8" class="pr-sm-0">
          <div>
            <div ref="text__compentency-title" class="text__compentency-title mb-2">
              <b>Competency</b>
            </div>

            <base-text-editor-display
              v-if="$_feedMixin_learningUnit && $_feedMixin_learningUnit.competency_detail"
            >
              <div
                ref="text__compentency-description"
                v-safe-html="$_feedMixin_learningUnit.competency_detail"
                class="text__compentency-description text-pre-line"
              ></div>
            </base-text-editor-display>
          </div>
          <!-- <list-session
            v-if="$_feedMixin_learningUnit && $_feedMixin_section"
            :section="$_feedMixin_section"
            :learning-unit="$_feedMixin_learningUnit"
            :show-enroll="false"
            :show-manage-button="false"
            :show-title-as-link="false"
            :col-row="12"
            editable
            :disabled="disabled"
            :feed-route="{
              name:
                mode === 'instructor'
                  ? 'design-planning/teaching-feed'
                  : 'review-learning-unit/teaching-feed',
              params: {
                sectionId: $_feedMixin_section.id,
                learningUnitId: $_feedMixin_section.learning_unit_id,
              },
            }"
            class="mb-4"
          ></list-session> -->
        </b-col>

        <b-col sm="4" class="pl-sm-0 mb-4 mb-sm-0 text-center text-sm-right">
          <b-row align-h="end">
            <b-col md="10" xl="8">
              <b-button-group class="btn-block">
                <b-button
                  ref="button__view-feed"
                  :variant="$_view === 'feed' ? 'dark' : 'outline-dark'"
                  class="button__to-post-feed-page"
                  :class="{ active: $_view === 'feed' }"
                  @click="setView('feed')"
                >
                  <font-awesome-icon icon="list-alt" label="view-feed" />
                </b-button>

                <b-button
                  ref="button__view-list"
                  :variant="$_view === 'list' ? 'dark' : 'outline-dark'"
                  class="button__to-post-list-page"
                  :class="{ active: $_view === 'list' }"
                  @click="setView('list')"
                >
                  <font-awesome-icon icon="list" label="view-list" />
                </b-button>

                <b-button
                  ref="button__view-alignment"
                  :variant="$_view === 'alignment' ? 'dark' : 'outline-dark'"
                  class="button__to-post-alignment-page"
                  :class="{ active: $_view === 'alignment' }"
                  @click="setView('alignment')"
                >
                  <font-awesome-icon icon="folder-tree" label="view-alignment" />
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- <b-row>
        <b-col>
          <list-session
            v-if="$_feedMixin_learningUnit && $_feedMixin_section"
            :section="$_feedMixin_section"
            :learning-unit="$_feedMixin_learningUnit"
            :show-enroll="false"
            :show-manage-button="false"
          ></list-session>
        </b-col>
      </b-row> -->

      <feed-post
        v-if="$_view === 'feed' && user && $_feedMixin_learningUnit && $_feedMixin_section"
        :learning-unit="$_feedMixin_learningUnit"
        :section="$_feedMixin_section"
        :disabled="disabled"
        :user="user"
      />

      <page-post
        v-if="$_view === 'list' && user && $_feedMixin_learningUnit && $_feedMixin_section"
        :learning-unit="$_feedMixin_learningUnit"
        :section="$_feedMixin_section"
        :disabled="disabled"
        :user="user"
        class="mt-4"
      />

      <post-alignment
        v-if="$_view === 'alignment' && user && $_feedMixin_learningUnit && $_feedMixin_section"
        :learning-unit="$_feedMixin_learningUnit"
        :section="$_feedMixin_section"
        :disabled="disabled"
        :user="user"
      />
    </b-col>
  </b-row>
</template>

<script>
import { feedMixin } from '@/mixins/feedMixin';
import { userInfoMixin } from '@/mixins/userInfoMixin';
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';
import LearningUnitHeader from '@/components/LearningUnit/LearningUnitHeader';
// import ListSession from "@/views/Section/components/ListSession";
import FeedPost from './components/FeedPost';
import LearningUnit from '@/models/LearningUnit';
import PagePost from '../Post/PagePost';
import PostAlignment from '@/components/Post/PostAlignment';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';

export default {
  components: {
    BaseBreadCrumb,
    BaseTextEditorDisplay,
    FeedPost,
    PagePost,
    LearningUnitHeader,
    // ListSession,
    PostAlignment
  },

  mixins: [feedMixin, userInfoMixin],
  props: {
    mode: {
      type: String,
      default: 'instructor'
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    $_view: {
      get() {
        return this.$route.query.view || 'feed';
      },

      set(view) {
        this.$router.push({
          name:
            this.mode === 'instructor'
              ? 'design-planning/teaching-feed'
              : 'review-learning-unit/teaching-feed',
          params: {
            learningUnitId: this.$_feedMixin_learningUnitId,
            sectionId: this.$_feedMixin_sectionId
          },
          query: {
            ...this.$route.query,
            view
          }
        });
      }
    },

    breadcrumbs() {
      const { $_feedMixin_learningUnit } = this;

      return [
        {
          key: this.mode === 'instructor' ? 'design-and-planning' : 'review-learning-unit',
          name:
            this.mode === 'instructor'
              ? 'Design and planning'
              : 'Review Submitted Micro-Credentials',
          to: {
            name: this.mode === 'instructor' ? 'design-planning' : 'review-learning-unit'
          }
        },
        {
          key: 'learning-unit-info',
          name: $_feedMixin_learningUnit ? $_feedMixin_learningUnit.name : '',
          to: {
            name: this.mode === 'instructor' ? 'design-planning/info' : 'review-learning-unit/edit',
            params: {
              learningUnitId: $_feedMixin_learningUnit ? $_feedMixin_learningUnit.id : null
            }
          }
        },
        {
          key: 'teaching-feed',
          name: 'Teaching feed',
          active: true
        }
      ];
    }
  },

  watch: {
    '$route.path': {
      immediate: true,
      handler: 'onRouteChanged'
    }
  },

  methods: {
    setView(view) {
      if (this.$_view !== view) {
        this.$_view = view;
      }
    },

    async onRouteChanged() {
      await this.fetch();
    },

    async fetch() {
      await LearningUnit.api().fetchByLearningUnitId(this.$_feedMixin_learningUnitId);

      if (this.mode === 'instructor' && !this.$_feedMixin_learningUnit.canAccess(this.user.id)) {
        this.$router.replace({ name: 'learning-unit' });
      }
    },

    gotoPreviousPage() {
      if (this.$route.query.previousPath) {
        const { previousPath } = this.$route.query;

        this.$router.push({ path: previousPath });
      } else {
        this.$router.go(-1);
      }
    },

    goToCreatePost() {
      this.$router.push({
        name: 'design-planning/post/create',
        params: { sectionId: this.$_feedMixin_sectionId },
        query: {
          previousPath: this.$route.fullPath
        }
      });
    }
  }
};
</script>
